// const API_BASE_URL = " https://c805-183-83-217-152.ngrok-free.app/api/v1";
// const API_BASE_URL = "http://localhost:3306/api/v1";
// const API_BASE_URL = "https://fapi.rizee.in/api/v1";
const API_BASE_URL = "https://rizee-farmers-backend-755214126997.us-south1.run.app/api/v1";

const API_ENDPOINTS = {
    LOGIN: `${API_BASE_URL}/auth/login`,
    YEARS: `${API_BASE_URL}/common/years`,
    LEVELS: `${API_BASE_URL}/common/levels`,
    USERLEVELS: `${API_BASE_URL}/common/user-levels`,
    TRAININGS_STATUS: `${API_BASE_URL}/common/training-status`,
    SOIL_TYPES: `${API_BASE_URL}/common/soil-types`,
    CROP_TYPES: `${API_BASE_URL}/common/crop-types`,
    EMPLOYEES: `${API_BASE_URL}/employees`,
    FARMERS: `${API_BASE_URL}/farmers`,
    ATTENDANCE: `${API_BASE_URL}/attendance`,
    ADD_ATTENDANCE: `${API_BASE_URL}/attendance`,

    GET_TRAINING_PLANS: `${API_BASE_URL}/training-plans`,
    CREATE_TRAINING_PLANS: `${API_BASE_URL}/training-plans`,
    UPDATE_TRAINING_PLANS: `${API_BASE_URL}/training-plans/:id`,
    DELETE_TRAINING_PLANS: `${API_BASE_URL}/training-plans/:id`,
    GET_TRAINING_SESSIONS_REPORT: `${API_BASE_URL}/training-plans/session-report`,
    GET_TRAINING_REPORT: `${API_BASE_URL}/training-plans/report`,
    GET_INDIVIDUAL_FARMER_DETAILS: `${API_BASE_URL}/training-plans/individualFarmerDetails`,


    TRAINING_SESSIONS: `${API_BASE_URL}/training-sessions`,
    CREATE_TRAINING_SESSIONS: `${API_BASE_URL}/training-sessions`,
    UPDATE_TRAINING_SESSIONS: `${API_BASE_URL}/training-sessions/:id`,
    DELETE_TRAINING_SESSIONS: `${API_BASE_URL}/training-sessions/:id`,

    SOIL_REPORT: `${API_BASE_URL}/soil-test-reports/:id`,
    CREATE_SOIL_REPORT: `${API_BASE_URL}/soil-test-reports`,
    UPDATE_SOIL_REPORT: `${API_BASE_URL}/soil-test-reports/:reportId`,
    UPDATE_VILLAGE_SOIL_REPORT: `${API_BASE_URL}/soil-test-reports/update-village`,
    DELETE_SOIL_REPORT: `${API_BASE_URL}/soil-test-reports/:id`,
    GET_SOIL_REPORT_SUMMARY: `${API_BASE_URL}/soil-test-reports/summary`,

    GET_MODULE_PAGES: `${API_BASE_URL}/common/module-pages`,
    CREATE_EMPLOYEE: `${API_BASE_URL}/employees`,
    GET_VILLAGES_GROUPS: `${API_BASE_URL}/village-groups`,
    FILEUPLOAD: `${API_BASE_URL}/common/flie-upload`,
    GET_SOIL_REPORTS: `${API_BASE_URL}/soil-test-reports`,

    CREATE_FIELD_BOOK: `${API_BASE_URL}/fieldbook/create`,
    GET_fIELD_BOOK: `${API_BASE_URL}/fieldbook`,
    DELETE_FIELD_BOOK: `${API_BASE_URL}/fieldbook/delete/:id`,
    UPDATE_FIELD_BOOK: `${API_BASE_URL}/fieldbook/updateBook/:id`,
    GET_FIELD_BOOK_SUMMARY: `${API_BASE_URL}/fieldbook/summary`,


    CREATE_ADOPTION: `${API_BASE_URL}/adoption/create`,
    GET_ADOPTION: `${API_BASE_URL}/adoption/getReports`,
    DELETE_ADOPTION: `${API_BASE_URL}/adoption/delete`,
    UPDATE_ADOPTION: `${API_BASE_URL}/adoption/update`,
    GET_ADOPTION_SUMMARY: `${API_BASE_URL}/adoption/getSummary`,
    GET_VILLAGE_GROUP_ADOPTION_SUMMARY: `${API_BASE_URL}/adoption/getGroupVillageWiseSummary`,

    GET_TRAINING_TYPES: `${API_BASE_URL}/common/trining_Types`,
    GET_PLANREPORT_SUMMARY: `${API_BASE_URL}/dashboard/getTrainingPlanLevelWiseReport`,
};
export default API_ENDPOINTS;   
